import React from "react";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();
  return (
    <main className="page-shell max-w-3xl">
      <p className="eyebrow mb-3">{t("legal.eyebrow")}</p>
      <h1 className="font-serif text-4xl font-bold text-gold-700">{t("legal.privacyTitle")}</h1>
      <div className="mt-8 space-y-6 text-sm leading-7 text-gray-600">
        <p>{t("legal.privacyIntro")}</p>
        <h2 className="font-serif text-2xl font-bold text-gold-700">{t("legal.howUseTitle")}</h2>
        <p>{t("legal.howUseText")}</p>
        <h2 className="font-serif text-2xl font-bold text-gold-700">{t("legal.choicesTitle")}</h2>
        <p>{t("legal.choicesText")}</p>
      </div>
    </main>
  );
};

export default Privacy;
